import type { ComputedRef, MaybeRefOrGetter } from 'vue';
import type { MonospaceFile } from '#layers/data-model';
import { computed, toValue } from 'vue';
import { useRuntimeConfig } from '#app/nuxt';
import { useProjectStore } from '~/stores/project';
import { getAssetURL } from '~/utils/assets';

export function useProjectAssetURL<F extends MonospaceFile | null>(file: MaybeRefOrGetter<F>): ComputedRef<F extends null ? string | null : string>;
export function useProjectAssetURL<I extends string | null>(id: I): ComputedRef<I extends null ? string | null : string>;

export function useProjectAssetURL(fileOrId: MaybeRefOrGetter<MonospaceFile | string | null>) {
	const { currentProjectSlug } = useProjectStore();
	const runtimeConfig = useRuntimeConfig();

	return computed(() => {
		const fileOrIdValue = toValue(fileOrId);
		return fileOrIdValue
			? getAssetURL(fileOrIdValue, { apiBase: runtimeConfig.public.api, projectSlug: currentProjectSlug.value ?? undefined })
			: null;
	});
}
